"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.function.name.js");

var _market = require("@/model/exchange/market.js");

var _orderDetails = _interopRequireDefault(require("../../ucenter/pages/bill-center/components/orderDetails.vue"));

var _index = require("@/model/exchange/index");

var _order = require("@/model/contractExchange/order.js");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index2 = require("@/utils/index.js");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _message = require("@/components/dialog/message.js");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _settings = require("@/model/settings");

var _keymap = require("@/assets/js/keymap.js");

var _digital = require("@/assets/js/digital");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  mixins: [_commonMixin.default],
  props: {
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    swap_symbol_id: {
      type: [String, Number],
      default: function _default() {
        return 1010;
      }
    },
    assetsInfo: {
      type: Object,
      default: function _default() {
        return {
          remain: {
            all_u_valuation: {
              usdt: "--"
            },
            list: []
          }
        };
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: String,
      default: "USDT"
    },
    from_item_id: {
      type: [String, Number]
    },
    to_item_id: {
      type: [String, Number]
    }
  },
  components: {
    NoData: _NoData.default,
    InputNumber: _InputNumber.default,
    OrderDetails: _orderDetails.default
  },
  data: function data() {
    return {
      currRow: {},
      closePositionTypeMaps: _keymap.closePositionTypeMaps,
      parseTime: _index2.parseTime,
      ws: null,
      tableData: [],
      confirmMessage: "是否确认平仓此订单？",
      tableDataComputed: [],
      orderLoading: true,
      appendMoneyLoading: false,
      profitLossLoading: false,
      liquidationLoading: false,
      dialogVisible: false,
      appendMoneydialog: false,
      setProfitPricedialog: false,
      row_swap_symbol_id: this.swap_symbol_id,
      beforeBailNumber: "",
      afterBailNumber: "--",
      inputProfitPrice: "",
      inputLossPrice: "",
      price_precision: "2",
      contract_plan_num: 0,
      contract_position_num: 0,
      contract_multiple_num: "",
      beforeLiquidationPrice: "",
      plan_order_id: "",
      afterLiquidationPrice: "--",
      rowData: {},
      hidenCancelChecked: false,
      checked: false,
      layout: "total, prev, pager, next",
      symbolId: "",
      position_order_id: "",
      bail_number: "",
      contractMultipleNum: {},
      pageInfo: {
        pageCount: 1,
        pageCurrent: 1,
        pageSize: 6,
        pageTotal: 6
      },
      apiAssetsInfo: {},
      tabList: [{
        value: "1",
        label: "持仓"
      }, {
        value: "2",
        label: "当前委托"
      }, {
        value: "3",
        label: "历史委托"
      }, {
        value: "4",
        label: "平仓记录"
      }],
      currIndex: "1",
      symbolList: {},
      coinInfoMap: {},
      triggerSideMap: {
        1: "大于触发价",
        2: "小于触发价"
      },
      tradeMap: {
        1: "市价",
        2: "限价"
      },
      sideMap: {
        1: "买涨",
        2: "买跌"
      },
      statusMap: {
        0: "未成交",
        1: "待成交",
        2: "完全成交",
        3: "已撤销",
        4: "失败"
      }
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$Account$getUse, userInfo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getCoinInfoMap();

            case 2:
              _context.next = 4;
              return _this.getTradePairList();

            case 4:
              _this.getOrderNumber();

              _this.getAssets();

              _context.next = 8;
              return Account.getUserInfo();

            case 8:
              _yield$Account$getUse = _context.sent;
              userInfo = _yield$Account$getUse.userInfo;

              if (userInfo) {
                _this.initData(_this.checked);

                _this.startTimer();
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {// clearTimeout(timer);
  },
  mounted: function mounted() {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    marketInfoShow: function marketInfoShow() {
      var _this2 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this2.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    rowMarketInfoShow: function rowMarketInfoShow() {
      var _this3 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this3.row_swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      var _this4 = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "--";
      }

      return tempObj;
    },
    afterLiquidationPriceShow: function afterLiquidationPriceShow() {
      // 强平价 = 开仓价 - (1 做多 | -1做空)) ×(保证金 × (1 − 强平⻛险率) - 平仓手续费-开仓手续费)/持仓数量
      var tempValue = "";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.bail_number != "") {
        tempValue = this.rowData.open_price - tempSide * (this.afterBailNumberShow * (1 - this.symbolList[this.swap_symbol_id].liquidation_risk_rate / 10000) - this.rowData.close_position_fee - this.rowData.open_position_fee) / this.rowData.open_interest;

        if (this.rowData.open_side == 1) {
          //做多 做多的时候小数位用全进
          tempValue = (Math.ceil(tempValue * Math.pow(10, this.price_precision)) / Math.pow(10, this.price_precision)).toFixed(this.price_precision);
        } else {
          // 做空的时候用截断
          tempValue = tempValue.toString().substring(0, tempValue.toString().indexOf(".") + this.price_precision + 1);
        }
      } else {
        tempValue = this.afterLiquidationPrice;
      }

      if (Number(tempValue) < 0) {
        tempValue = "0";
      }

      return tempValue;
    },
    afterBailNumberShow: function afterBailNumberShow() {
      return (Number(this.afterBailNumber) + Number(this.bail_number)).toFixed(2);
    },
    // 平仓盈亏 = (inputProfitPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量
    expectedProfit: function expectedProfit() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (Number(this.inputProfitPrice) - Number(temp_open_price)) * tempSide * Number(this.rowData.open_interest);
        tempValue = Number(tempValue) > 0 ? (0, _digital.floorNumber)(tempValue, 2) : (0, _digital.ceilNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        }
      } // inputProfitPrice


      return tempValue;
    },
    expectedProfitPercent: function expectedProfitPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (this.inputProfitPrice - temp_open_price) * tempSide * this.rowData.open_interest / this.rowData.bail_number * 100;
        tempValue = Number(tempValue) > 0 ? (0, _digital.floorNumber)(tempValue, 2) : (0, _digital.ceilNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        } else {
          tempValue = "+" + tempValue;
        }
      } // inputProfitPrice


      return tempValue;
    },
    // 平仓盈亏 = (inputLossPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量
    expectedLoss: function expectedLoss() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest;
        tempValue = Number(tempValue) > 0 ? (0, _digital.floorNumber)(tempValue, 2) : (0, _digital.ceilNumber)(tempValue, 2); // tempValue = Math.ceil(tempValue * 100) / 100;

        if (Number(tempValue) < this.rowData.bail_number * -1) {
          tempValue = this.rowData.bail_number * -1;
        }

        if (Number(tempValue) > 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    },
    expectedLossPercent: function expectedLossPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest / this.rowData.bail_number * 100;
        tempValue = Number(tempValue) > 0 ? (0, _digital.floorNumber)(tempValue, 2) : (0, _digital.ceilNumber)(tempValue, 2);

        if (Number(tempValue) < -100) {
          tempValue = -100;
        }

        if (Number(tempValue) >= 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    }
  }),
  methods: {
    routeSplicing: _routeSplicing.default,
    onOK: function onOK() {
      this.liquidationLoading = true;

      if (this.dialogType == 1) {
        this.onClosePosition();
      } else if (this.dialogType == 2) {
        this.onCancelOrder();
      } else if (this.dialogType == 3) {
        this.onRevokeAllOrder();
      } else if (this.dialogType == 4) {
        this.onRevokePlan();
      }
    },
    goToRecharge: function goToRecharge() {
      window.open(this.routeSplicing(this.language, "ucenter/assets/recharge/usdt"));
    },
    onClearAll: function onClearAll() {
      this.inputProfitPrice = "";
    },
    onClearAllV2: function onClearAllV2() {
      this.inputLossPrice = "";
    },
    setProfitPricedialogClose: function setProfitPricedialogClose() {
      this.inputLossPrice = "";
      this.inputProfitPrice = "";
      this.setProfitPricedialog = false;
    },
    appendMoneydialogClose: function appendMoneydialogClose() {
      this.bail_number = "";
      this.appendMoneydialog = false;
    },
    onClickAll: function onClickAll() {
      this.bail_number = this.assetsInfoShow;
    },
    reset: function reset(type) {
      this.orderLoading = true;
      this.currIndex = type.toString();
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
      this.getOrderNumber();
    },
    getAssets: function getAssets() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this5.apiAssetsInfo = data;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onProfitPriceEdit: function onProfitPriceEdit(row) {
      this.rowData = row;

      for (var key in this.symbolList) {
        if (key == row.symbol_id) {
          this.price_precision = this.symbolList[key].price_precision;
        }
      }

      this.row_swap_symbol_id = row.symbol_id;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    onLossPriceEdit: function onLossPriceEdit(row) {
      this.rowData = row;
      this.row_swap_symbol_id = row.symbol_id;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    getCoinInfoMap: function getCoinInfoMap() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this6.coinInfoMap = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getTradePairList: function getTradePairList() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$apiGetStaticTa2, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa2 = _context4.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this7.symbolList = data;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onSymbolChange: function onSymbolChange(item) {
      this.$emit("on-symbol-change", item);
    },
    onSymbolClick: function onSymbolClick(row) {
      var tempName = "";

      if (row.from_symbol_name) {
        tempName = row.from_symbol_name.toLowerCase() + "_" + "usdt";
      } else {
        for (var key in this.coinInfoMap) {
          if (key == row.open_item_id) {
            tempName = this.coinInfoMap[key].item_name.toLowerCase() + "_" + "usdt";
          }
        }
      }

      var params = {
        symbol_id: row.symbol_id,
        name: tempName,
        change_item_id: row.open_item_id,
        base_item_id: row.settlement_item_id
      };
      this.$emit("on-symbol-change", params);
    },
    onOpenConfirm: function onOpenConfirm(type, id) {
      this.dialogType = type;

      if (type == 1) {
        this.position_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认平仓此订单？");
      } else if (type == 2) {
        this.confirmMessage = this.translateTitle("是否确认全部平仓？");
      } else if (type == 3) {
        this.confirmMessage = this.translateTitle("是否确认全部撤销？");
      } else if (type == 4) {
        this.plan_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认撤销此委托单？");
      }

      this.dialogVisible = true;
    },
    onOpenOrderDetails: function onOpenOrderDetails(assets_type, row) {
      // this.currRow
      var tempRow = {
        order_info: {
          position_order_id: row.position_order_id
        },
        assets_type: assets_type
      };
      this.$refs.orderDetails.liquidationContractInfoClick(tempRow);
    },
    onOpenAppendMoney: function onOpenAppendMoney(row) {
      this.position_order_id = row.position_order_id;
      this.beforeBailNumber = row.bail_number;
      this.afterBailNumber = row.bail_number;
      this.beforeLiquidationPrice = row.liquidation_price;
      this.afterLiquidationPrice = row.liquidation_price;
      this.rowData = row;

      for (var key in this.symbolList) {
        if (key == row.symbol_id) {
          this.price_precision = this.symbolList[key].price_precision;
        }
      }

      this.appendMoneydialog = true;
    },
    onClosePosition: function onClosePosition() {
      var _this8 = this;

      var params = {
        position_order_id: this.position_order_id
      };
      (0, _order.apiClosePosition)(params).then(function (res) {
        if (res.status == 200) {
          _this8.dialogVisible = false;
          (0, _message.showMessage)({
            message: _this8.translateTitle("平仓成功"),
            type: "success" // duration:10000000,

          });
          _this8.liquidationLoading = false;

          _this8.initData(_this8.checked);
        } else {
          _this8.dialogVisible = false;
          _this8.liquidationLoading = false;
        }
      });
    },
    onAppendMoney: function onAppendMoney() {
      var _this9 = this;

      if (Number(this.bail_number) == 0) {
        (0, _message.showMessage)({
          message: this.translateTitle("请输入追加金额"),
          type: "error"
        });
        return;
      }

      this.appendMoneyLoading = true;
      var params = {
        position_order_id: this.position_order_id,
        bail_number: this.bail_number
      };
      (0, _order.apiAppendInterest)(params).then(function (res) {
        if (res.status == 200) {
          (0, _message.showMessage)({
            message: _this9.translateTitle("追加成功"),
            type: "success"
          });
          _this9.appendMoneyLoading = false;
          _this9.appendMoneydialog = false;

          _this9.initData(_this9.checked);
        } else {
          _this9.appendMoneyLoading = false;
        }
      });
    },
    startTimer: function startTimer() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var timer;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                timer = setTimeout(function () {
                  _this10.loopData(_this10.checked); // this.initData(this.checked);
                  // this.getOrderNumber();
                  // this.getMultipleNum();


                  _this10.startTimer();
                }, 3000);

                _this10.$once("hook:beforeDestroy", function () {
                  clearTimeout(timer);
                });

                _this10.$once("hook:destroyed", function () {
                  clearTimeout(timer);
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onCancelOrder: function onCancelOrder() {
      var _this11 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$apiAllClosePos, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _order.apiAllClosePosition)();

              case 2:
                _yield$apiAllClosePos = _context6.sent;
                status = _yield$apiAllClosePos.status;
                data = _yield$apiAllClosePos.data;

                if (status == 200) {
                  _this11.dialogVisible = false;
                  (0, _message.showMessage)({
                    message: _this11.translateTitle("平仓成功"),
                    type: "success"
                  });
                  _this11.liquidationLoading = false;

                  _this11.initData(_this11.checked);
                } else {
                  _this11.liquidationLoading = false;
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onRevokeAllOrder: function onRevokeAllOrder() {
      var _this12 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$apiRevokeAllPl, status, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _order.apiRevokeAllPlan)();

              case 2:
                _yield$apiRevokeAllPl = _context7.sent;
                status = _yield$apiRevokeAllPl.status;
                data = _yield$apiRevokeAllPl.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this12.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this12.dialogVisible = false;
                  _this12.liquidationLoading = false;

                  _this12.initData(_this12.checked);
                } else {
                  _this12.liquidationLoading = false;
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onRevokePlan: function onRevokePlan() {
      var _this13 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var req, _yield$apiRevokePlan, status, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                req = {
                  plan_order_id: _this13.plan_order_id
                };
                _context8.next = 3;
                return (0, _order.apiRevokePlan)(req);

              case 3:
                _yield$apiRevokePlan = _context8.sent;
                status = _yield$apiRevokePlan.status;
                data = _yield$apiRevokePlan.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this13.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this13.dialogVisible = false;
                  _this13.liquidationLoading = false;

                  _this13.initData(_this13.checked);
                } else {
                  _this13.liquidationLoading = false;
                }

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onSetPositionProfitLoss: function onSetPositionProfitLoss() {
      var _this14 = this;

      if (this.currIndex == 1) {
        if (this.rowData.open_side == 1) {
          if (Number(this.rowMarketInfoShow.last) < Number(this.rowData.open_price)) {
            if (Number(this.inputProfitPrice) != 0 && Number(this.inputProfitPrice) <= Number(this.rowData.open_price)) {
              (0, _message.showMessage)({
                message: this.translateTitle("买涨时，止盈价需大于开仓价"),
                type: "warning"
              });
              return;
            }
          } else {
            if (Number(this.inputProfitPrice) != 0 && Number(this.inputProfitPrice) <= Number(this.rowMarketInfoShow.last)) {
              (0, _message.showMessage)({
                message: this.translateTitle("买涨时，止盈价需大于当前价"),
                type: "warning"
              });
              return;
            }
          } // if(止损价 > 强平价){
          // 	if(当前价 < 开仓价){
          // 		止损价 >= 当前价 ? "提示：买涨时，止损价需小于当前价" ：止损价
          // 	}else{
          // 		止损价 >= 开仓价 ? "提示：买涨时，止损价需小于开仓价" ：止损价
          // 	}
          // esle{
          // 	提示：买涨时，止损价需大于强平价
          // }


          if (Number(this.inputLossPrice) != 0 && Number(this.inputLossPrice) >= Number(this.rowData.liquidation_price)) {
            if (Number(this.rowMarketInfoShow.last) < Number(this.rowData.open_price)) {
              if (Number(this.inputLossPrice) >= Number(this.rowMarketInfoShow.last)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买涨时，止损价需小于当前价"),
                  type: "warning"
                });
                return;
              }
            } else {
              if (Number(this.inputLossPrice) >= Number(this.rowData.open_price)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买涨时，止损价需小于开仓价"),
                  type: "warning"
                });
                return;
              }
            }
          } else if (Number(this.inputLossPrice) != 0) {
            Number(this.inputLossPrice) < Number(this.rowData.liquidation_price);
            (0, _message.showMessage)({
              message: this.translateTitle("买涨时，止损价需大于强平价"),
              type: "warning"
            });
            return;
          }
        } else {
          // 卖跌
          if (Number(this.inputProfitPrice) > 0) {
            if (Number(this.rowMarketInfoShow.last) < Number(this.rowData.open_price)) {
              if (Number(this.inputProfitPrice) >= Number(this.rowMarketInfoShow.last)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买跌时，止盈价需小于当前价"),
                  type: "warning"
                });
                return;
              }
            } else {
              if (Number(this.inputProfitPrice) >= Number(this.rowData.open_price)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买跌时，止盈价需小于开仓价"),
                  type: "warning"
                });
                return;
              }
            }
          } else if (Number(this.inputProfitPrice) < 0) {
            (0, _message.showMessage)({
              message: this.translateTitle("买跌时，止盈价需大于0"),
              type: "warning"
            });
            return;
          } // if(止损价 < 强平价){
          // 	if(当前价 < 开仓价){
          // 		止损价  <= 开仓价 ? "提示：买跌时，止损价需大于开仓价" ：止损价
          // 	}else{
          // 		止损价 <= 当前价 ? "提示：买跌时，止损价需大于当前价" ：止损价
          // 	}
          // esle{
          // 	提示：买跌时，止损价需小于强平价
          // }


          if (Number(this.inputLossPrice) != 0 && Number(this.inputLossPrice) <= Number(this.rowData.liquidation_price)) {
            if (Number(this.rowMarketInfoShow.last) < Number(this.rowData.open_price)) {
              if (Number(this.inputLossPrice) <= Number(this.rowData.open_price)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买跌时，止损价需大于开仓价"),
                  type: "warning"
                });
                return;
              }

              if (Number(this.inputLossPrice) <= Number(this.rowMarketInfoShow.last)) {
                (0, _message.showMessage)({
                  message: this.translateTitle("买跌时，止损价需大于当前价"),
                  type: "warning"
                });
                return;
              }
            }
          } else if (Number(this.inputLossPrice) != 0) {
            (0, _message.showMessage)({
              message: this.translateTitle("买跌时，止损价需小于强平价"),
              type: "warning"
            });
            return;
          }
        }

        var tempInputProfitPrice = "";

        if (Number(this.inputProfitPrice) == 0) {
          tempInputProfitPrice = "";
        } else {
          tempInputProfitPrice = this.inputProfitPrice;
        }

        var tempInputLossPrice = "";

        if (Number(this.inputLossPrice) == 0) {
          tempInputLossPrice = "";
        } else {
          tempInputLossPrice = this.inputLossPrice;
        }

        this.profitLossLoading = true;
        var params = {
          position_order_id: this.rowData.position_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: tempInputProfitPrice,
          stop_loss_price: tempInputLossPrice
        };
        (0, _order.apiSetPositionProfitLoss)(params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this14.translateTitle("设置成功"),
              type: "success"
            });
            _this14.profitLossLoading = false;

            _this14.setProfitPricedialogClose();

            _this14.initData(_this14.checked);
          } else {
            _this14.profitLossLoading = false;
          }
        });
      } else {
        //委托单 止盈止损
        if (this.rowData.open_side == 1) {
          ////委托单  买涨
          // 止盈价 <= 开仓价 ? "提示：买涨时，止盈价需大于开仓价" ：止盈价
          if (Number(this.inputProfitPrice) != 0 && Number(this.inputProfitPrice) <= Number(this.rowData.trigger_price)) {
            (0, _message.showMessage)({
              message: this.translateTitle("买涨时，止盈价需大于开仓价"),
              type: "warning"
            });
            return;
          } //  if(止损价 > 强平价){
          //         止损价 >= 开仓价 ? "提示：买涨时，止损价需小于开仓价" ：止损价
          // esle{
          // 	提示：买涨时，止损价需大于强平价
          // }


          if (Number(this.inputLossPrice) != 0 && Number(this.inputLossPrice) >= Number(this.rowData.liquidation_price)) {
            if (Number(this.inputLossPrice) >= Number(this.rowData.trigger_price)) {
              (0, _message.showMessage)({
                message: this.translateTitle("买涨时，止损价需小于开仓价"),
                type: "warning"
              });
              return;
            }
          } else if (Number(this.inputLossPrice) != 0) {
            (0, _message.showMessage)({
              message: this.translateTitle("买涨时，止损价需大于强平价"),
              type: "warning"
            });
            return;
          }
        } else {
          //委托单  //买跌 开仓价 trigger_price
          if (Number(this.inputProfitPrice) > 0) {
            if (Number(this.inputProfitPrice) >= Number(this.rowData.trigger_price)) {
              (0, _message.showMessage)({
                message: this.translateTitle("买跌时，止盈价需小于开仓价"),
                type: "warning"
              });
              return;
            }
          } else if (Number(this.inputProfitPrice) < 0) {
            (0, _message.showMessage)({
              message: this.translateTitle("买跌时，止盈价需大于0"),
              type: "warning"
            });
            return;
          } //liquidation_price 强平价
          // if(止损价 < 强平价  ){
          // 	止损价 <= 开仓价 ? "提示：买跌时，止损价需大于开仓价" ：止损价
          // esle{
          // 	提示：买跌时，止损价需小于强平价 liquidation_price
          // }


          if (Number(this.inputLossPrice) != 0 && Number(this.inputLossPrice) <= Number(this.rowData.liquidation_price)) {
            if (Number(this.inputLossPrice) <= Number(this.rowData.trigger_price)) {
              (0, _message.showMessage)({
                message: this.translateTitle("买跌时，止损价需大于开仓价"),
                type: "warning"
              });
              return;
            }
          } else if (Number(this.inputLossPrice) != 0) {
            (0, _message.showMessage)({
              message: this.translateTitle("买跌时，止损价需小于强平价"),
              type: "warning"
            });
            return;
          }
        }

        var _tempInputProfitPrice = "";

        if (Number(this.inputProfitPrice) == 0) {
          _tempInputProfitPrice = "";
        } else {
          _tempInputProfitPrice = this.inputProfitPrice;
        }

        var _tempInputLossPrice = "";

        if (Number(this.inputLossPrice) == 0) {
          _tempInputLossPrice = "";
        } else {
          _tempInputLossPrice = this.inputLossPrice;
        }

        this.profitLossLoading = true;
        var _params = {
          plan_order_id: this.rowData.plan_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: _tempInputProfitPrice,
          stop_loss_price: _tempInputLossPrice
        };
        (0, _order.apiSetPlanProfitLoss)(_params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this14.translateTitle("设置成功"),
              type: "success"
            });
            _this14.profitLossLoading = false;

            _this14.setProfitPricedialogClose();

            _this14.initData(_this14.checked);
          } else {
            _this14.profitLossLoading = false;
          }
        });
      }
    },
    onAreaChange: function onAreaChange(item) {
      this.orderLoading = true;
      this.tableData = [];
      this.currIndex = item.value;
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
    },
    getMultipleNum: function getMultipleNum() {
      var _this15 = this;

      if (!this.userInfo) {
        return;
      }

      var params = {
        symbol_id: this.checked ? this.swap_symbol_id : ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this15.contract_multiple_num = JSON.stringify(res.data.contract_multiple_num);
          localStorage.setItem("contract-multiple-num", _this15.contract_multiple_num);
          _this15.contract_position_num = res.data.contract_position_info.total_num;
          _this15.contract_plan_num = res.data.contract_plan_info.total_num;
        }
      });
    },
    getOrderNumber: function getOrderNumber() {
      var _this16 = this;

      if (!this.userInfo) {
        return;
      }

      var params = {
        symbol_id: this.checked ? this.swap_symbol_id : ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this16.contract_position_num = res.data.contract_position_info.total_num;
          _this16.contract_plan_num = res.data.contract_plan_info.total_num;
        }
      });
    },
    statisticAndFundingRate: function statisticAndFundingRate(data) {
      this.$emit("changeFundingRate", {
        fundForm: data.fundingRate,
        fundTime: data.fundingRate.time
      });
      this.contract_multiple_num = JSON.stringify(data.statistic.contract_multiple_num);
      localStorage.setItem("contract-multiple-num", this.contract_multiple_num);
      this.contract_position_num = data.statistic.contract_position_info.total_num;
      this.contract_plan_num = data.statistic.contract_plan_info.total_num;
    },
    loopData: function loopData() {
      var _arguments = arguments,
          _this17 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var checked, _yield$Account$getUse2, userInfo, params, _yield$apiGetContract, status, data, tempStatus, temp_symbol_id, temp_is_hide, req, _req, temp_order_status, _req2, _req3;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                checked = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                if (_this17.swap_symbol_id) {
                  _context9.next = 4;
                  break;
                }

                _this17.orderLoading = false;
                return _context9.abrupt("return");

              case 4:
                _context9.next = 6;
                return Account.getUserInfo();

              case 6:
                _yield$Account$getUse2 = _context9.sent;
                userInfo = _yield$Account$getUse2.userInfo;

                if (userInfo) {
                  _context9.next = 19;
                  break;
                }

                if (!_this17.swap_symbol_id) {
                  _context9.next = 17;
                  break;
                }

                params = {
                  module: "fundingRate",
                  "fundingRate-symbol_id": _this17.swap_symbol_id
                };
                _context9.next = 13;
                return (0, _order.apiGetContract)(params);

              case 13:
                _yield$apiGetContract = _context9.sent;
                status = _yield$apiGetContract.status;
                data = _yield$apiGetContract.data;

                if (status == 200) {
                  _this17.$emit("changeFundingRate", {
                    fundForm: data.fundingRate,
                    fundTime: data.fundingRate.time
                  });
                }

              case 17:
                _this17.orderLoading = false;
                return _context9.abrupt("return");

              case 19:
                tempStatus = _this17.currIndex;

                if (_this17.currIndex == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this17.swap_symbol_id;
                temp_is_hide = 2;

                if (checked) {
                  temp_symbol_id = _this17.swap_symbol_id;
                  temp_is_hide = 1;
                } else {
                  temp_symbol_id = "";
                  temp_is_hide = 2;
                }

                if (!(_this17.currIndex == 1)) {
                  _context9.next = 29;
                  break;
                }

                req = {
                  module: "fundingRate,openPositionList,statistic",
                  "openPositionList-symbol_id": temp_symbol_id,
                  "openPositionList-position_status": 1,
                  "openPositionList-page": _this17.pageInfo.pageCurrent,
                  "openPositionList-page_size": _this17.pageInfo.pageSize,
                  "statistic-symbol_id": _this17.checked ? _this17.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this17.swap_symbol_id // is_hide: temp_is_hide,

                }; //  return apiGetOpenPositionList(req).then((res) => {

                return _context9.abrupt("return", (0, _order.apiGetContract)(req).then(function (res) {
                  if (res.status == 200) {
                    _this17.statisticAndFundingRate(res.data);
                  }

                  if (res.status == 200 && res.data.openPositionList && res.data.openPositionList.list.length > 0) {
                    res.data.openPositionList.list.forEach(function (ele) {
                      // 存各个币种杠杆倍数
                      _this17.contractMultipleNum[ele.symbol_id] = {
                        open_leverage: ele.open_leverage
                      }; // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量

                      // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量
                      _this17.marketList.forEach(function (item) {
                        if (item.symbol_id == ele.symbol_id) {
                          ele.last_price = item.last;
                        }
                      });

                      var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

                      // 未实现盈亏
                      ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
                      ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);

                      for (var key in _this17.coinInfoMap) {
                        if (key == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[key].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.openPositionList.list;
                    _this17.pageInfo = res.data.openPositionList.pageInfo;
                  } else {
                    _this17.tableData = [];
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 29:
                if (!(_this17.currIndex == 2)) {
                  _context9.next = 34;
                  break;
                }

                _req = {
                  module: "fundingRate,planOrderList,statistic",
                  "planOrderList-symbol_id": temp_symbol_id,
                  "planOrderList-order_status": 1,
                  "planOrderList-is_hide": 2,
                  "planOrderList-page": _this17.pageInfo.pageCurrent,
                  "planOrderList-page_size": _this17.pageInfo.pageSize,
                  "statistic-symbol_id": _this17.checked ? _this17.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this17.swap_symbol_id
                }; // return apiGetPlanOrderList(req).then((res) => {

                return _context9.abrupt("return", (0, _order.apiGetContract)(_req).then(function (res) {
                  if (res.status == 200) {
                    _this17.statisticAndFundingRate(res.data);

                    var _loop = function _loop(key) {
                      res.data.planOrderList.list.forEach(function (ele) {
                        _this17.marketList.forEach(function (item) {
                          if (item.symbol_id == ele.symbol_id) {
                            ele.last_price = item.last;
                          }
                        });

                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this17.exchangeCoinMap) {
                      _loop(key);
                    }

                    _this17.tableData = res.data.planOrderList.list;
                    _this17.pageInfo = res.data.planOrderList.pageInfo;
                  } else {
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 34:
                if (!(_this17.currIndex == 3)) {
                  _context9.next = 41;
                  break;
                }

                temp_order_status = "2,3,4";

                if (_this17.hidenCancelChecked) {
                  temp_order_status = "2,4";
                } else {
                  temp_order_status = "2,3,4";
                }

                _req2 = {
                  module: "fundingRate,planOrderList,statistic",
                  "planOrderList-symbol_id": temp_symbol_id,
                  "planOrderList-order_status": temp_order_status,
                  "planOrderList-is_hide": 2,
                  "planOrderList-page": _this17.pageInfo.pageCurrent,
                  "planOrderList-page_size": _this17.pageInfo.pageSize,
                  "statistic-symbol_id": _this17.checked ? _this17.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this17.swap_symbol_id
                }; // return apiGetPlanOrderList(req).then((res) => {

                return _context9.abrupt("return", (0, _order.apiGetContract)(_req2).then(function (res) {
                  if (res.status == 200) {
                    _this17.statisticAndFundingRate(res.data);

                    res.data.planOrderList.list.forEach(function (ele) {
                      for (var key in _this17.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key in _this17.coinInfoMap) {
                        if (_key == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[_key].item_name.toUpperCase();
                        }

                        if (_key == ele.settlement_item_id) {
                          ele.to_symbol_name = _this17.coinInfoMap[_key].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.planOrderList.list;
                    _this17.pageInfo = res.data.planOrderList.pageInfo;
                  } else {
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 41:
                if (!(_this17.currIndex == 4)) {
                  _context9.next = 44;
                  break;
                }

                _req3 = {
                  module: "fundingRate,openPositionList,statistic",
                  "openPositionList-symbol_id": temp_symbol_id,
                  "openPositionList-position_status": 2,
                  "openPositionList-page": _this17.pageInfo.pageCurrent,
                  "openPositionList-page_size": _this17.pageInfo.pageSize,
                  "statistic-symbol_id": _this17.checked ? _this17.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this17.swap_symbol_id
                }; // return apiGetOpenPositionList(req).then((res) => {

                return _context9.abrupt("return", (0, _order.apiGetContract)(_req3).then(function (res) {
                  if (res.status == 200) {
                    _this17.statisticAndFundingRate(res.data);
                  }

                  if (res.status == 200 && res.data.openPositionList && res.data.openPositionList.list.length > 0) {
                    res.data.openPositionList.list.forEach(function (ele) {
                      for (var key in _this17.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key2 in _this17.coinInfoMap) {
                        if (_key2 == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[_key2].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.openPositionList.list;
                    _this17.pageInfo = res.data.openPositionList.pageInfo;
                  } else {
                    _this17.tableData = [];
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 44:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    initData: function initData() {
      var _arguments2 = arguments,
          _this18 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var checked, _yield$Account$getUse3, userInfo, tempStatus, temp_symbol_id, temp_is_hide, req, _req4, temp_order_status, _req5, _req6;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                checked = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;

                if (_this18.swap_symbol_id) {
                  _context10.next = 4;
                  break;
                }

                _this18.orderLoading = false;
                return _context10.abrupt("return");

              case 4:
                _context10.next = 6;
                return Account.getUserInfo();

              case 6:
                _yield$Account$getUse3 = _context10.sent;
                userInfo = _yield$Account$getUse3.userInfo;

                if (userInfo) {
                  _context10.next = 11;
                  break;
                }

                _this18.orderLoading = false;
                return _context10.abrupt("return");

              case 11:
                tempStatus = _this18.currIndex;

                if (_this18.currIndex == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this18.swap_symbol_id;
                temp_is_hide = 2;

                if (checked) {
                  temp_symbol_id = _this18.swap_symbol_id;
                  temp_is_hide = 1;
                } else {
                  temp_symbol_id = "";
                  temp_is_hide = 2;
                }

                if (!(_this18.currIndex == 1)) {
                  _context10.next = 21;
                  break;
                }

                req = {
                  symbol_id: temp_symbol_id,
                  position_status: 1,
                  page: _this18.pageInfo.pageCurrent,
                  page_size: _this18.pageInfo.pageSize // is_hide: temp_is_hide,

                };
                return _context10.abrupt("return", (0, _order.apiGetOpenPositionList)(req).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      // 存各个币种杠杆倍数
                      _this18.contractMultipleNum[ele.symbol_id] = {
                        open_leverage: ele.open_leverage
                      }; // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量

                      // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量
                      _this18.marketList.forEach(function (item) {
                        if (item.symbol_id == ele.symbol_id) {
                          ele.last_price = item.last;
                        }
                      });

                      var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

                      // 未实现盈亏
                      ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
                      ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);

                      for (var key in _this18.coinInfoMap) {
                        if (key == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[key].item_name.toUpperCase();
                        }
                      }
                    });
                    _this18.tableData = res.data.list;
                    _this18.pageInfo = res.data.pageInfo;
                  } else {
                    _this18.tableData = [];
                    _this18.orderLoading = false;
                  }

                  _this18.orderLoading = false;
                }));

              case 21:
                if (!(_this18.currIndex == 2)) {
                  _context10.next = 26;
                  break;
                }

                _req4 = {
                  symbol_id: temp_symbol_id,
                  order_status: 1,
                  is_hide: 2,
                  page: _this18.pageInfo.pageCurrent,
                  page_size: _this18.pageInfo.pageSize
                };
                return _context10.abrupt("return", (0, _order.apiGetPlanOrderList)(_req4).then(function (res) {
                  if (res.status == 200) {
                    var _loop2 = function _loop2(key) {
                      res.data.list.forEach(function (ele) {
                        _this18.marketList.forEach(function (item) {
                          if (item.symbol_id == ele.symbol_id) {
                            ele.last_price = item.last;
                          }
                        });

                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this18.exchangeCoinMap) {
                      _loop2(key);
                    }

                    _this18.tableData = res.data.list;
                    _this18.pageInfo = res.data.pageInfo;
                  } else {
                    _this18.orderLoading = false;
                  }

                  _this18.orderLoading = false;
                }));

              case 26:
                if (!(_this18.currIndex == 3)) {
                  _context10.next = 33;
                  break;
                }

                temp_order_status = "2,3,4";

                if (_this18.hidenCancelChecked) {
                  temp_order_status = "2,4";
                } else {
                  temp_order_status = "2,3,4";
                }

                _req5 = {
                  symbol_id: temp_symbol_id,
                  order_status: temp_order_status,
                  is_hide: 2,
                  page: _this18.pageInfo.pageCurrent,
                  page_size: _this18.pageInfo.pageSize
                };
                return _context10.abrupt("return", (0, _order.apiGetPlanOrderList)(_req5).then(function (res) {
                  if (res.status == 200) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this18.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key3 in _this18.coinInfoMap) {
                        if (_key3 == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[_key3].item_name.toUpperCase();
                        }

                        if (_key3 == ele.settlement_item_id) {
                          ele.to_symbol_name = _this18.coinInfoMap[_key3].item_name.toUpperCase();
                        }
                      }
                    });
                    _this18.tableData = res.data.list;
                    _this18.pageInfo = res.data.pageInfo;
                  } else {
                    _this18.orderLoading = false;
                  }

                  _this18.orderLoading = false;
                }));

              case 33:
                if (!(_this18.currIndex == 4)) {
                  _context10.next = 36;
                  break;
                }

                _req6 = {
                  symbol_id: temp_symbol_id,
                  position_status: 2,
                  page: _this18.pageInfo.pageCurrent,
                  page_size: _this18.pageInfo.pageSize
                };
                return _context10.abrupt("return", (0, _order.apiGetOpenPositionList)(_req6).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this18.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key4 in _this18.coinInfoMap) {
                        if (_key4 == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[_key4].item_name.toUpperCase();
                        }
                      }
                    });
                    _this18.tableData = res.data.list;
                    _this18.pageInfo = res.data.pageInfo;
                  } else {
                    _this18.tableData = [];
                    _this18.orderLoading = false;
                  }

                  _this18.orderLoading = false;
                }));

              case 36:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    onCurrentPageChange: function onCurrentPageChange() {
      this.orderLoading = true;
      this.initData(this.checked);
    }
  },
  watch: {
    swap_symbol_id: {
      handler: function handler(newVal, oldVal) {
        if (oldVal == undefined) {
          return;
        }

        if (newVal != oldVal) {
          this.symbolId = newVal;
          this.orderLoading = true;
          this.pageInfo.pageCurrent = 1;
          this.initData(this.checked);
        }
      }
    },
    hidenCancelChecked: function hidenCancelChecked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    checked: function checked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    marketList: function marketList() {
      var _this19 = this;

      if (this.currIndex == 1 || this.currIndex == 2) {
        this.tableData.forEach(function (ele) {
          _this19.marketList.forEach(function (item) {
            if (item.symbol_id == ele.symbol_id) {
              ele.last_price = item.last;
            }
          });

          var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

          ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
          ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);
        });
      }
    }
  }
};
exports.default = _default2;